import type { ReactNode } from 'react'
import React from 'react'

import * as S from './styled'

type Props = {
  children: ReactNode
}

export const MainInputsLayout = ({ children }: Props) => <S.Container>{children}</S.Container>
